import priorities from '@/store/constants/priorities.constants';

export default {
  headers: [{
    text: 'Task',
    align: 'left',
    value: 'title',
  },
  {
    text: 'Priority',
    value: 'priority',
  },
  {
    text: 'Status',
    value: 'status',
  },
  {
    text: 'Reporter',
    value: 'reporter.displayName',
  },
  {
    text: 'Created',
    value: 'createdAt',
  },
  {
    text: 'Actions',
    value: 'actions',
    sortable: false,
    align: 'center',
  },
  ],
  options: {
    loadingText: 'Loading Project... Please wait',
    showSelect: false,
    itemsPerPage: 15,
  },
  filterTabs: [
    {
      text: 'All',
      value: 'all',
    },
    ...priorities,
  ],
  actionItems: [{
    title: 'View Task',
    id: 'onView',
    action: 'onView',
    icon: 'mdi-open-in-new',
    match() {
      return true;
    },
  },
  // {
  //   title: 'Edit',
  //   id: 'onEdit',
  //   action: 'onEdit',
  //   icon: 'mdi-pencil',
  //   match() {
  //     return true;
  //   },
  // },
  // {
  //   title: 'Delete',
  //   id: 'onDelete',
  //   action: 'onDelete',
  //   icon: 'mdi-delete-outline',
  //   match() {
  //     return true;
  //   },
  // }
  ],
  bulkActionItems: [{
    title: 'Change Status',
    id: 'deleteAll',
    action: 'onMulitiChangeStatus',
    icon: 'mdi-swap-vertical',
  }, {
    title: 'Change Priority',
    id: 'deleteAll',
    action: 'onMulitiChangePriority',
    icon: 'mdi-swap-vertical',
  }],
};
